import React, { useState } from 'react'
import { Animated, View, StyleSheet } from 'react-native'
import theme from '../../../../theme'

export const Bullets = ({ bullets, currentIndex }) => {
    const bulletsArray = Array.from({ length: bullets }, (_, i) => i + 1)
    const startIndex = Math.max(0, currentIndex - 3) // Empieza a mostrar desde 3 antes del currentIndex
    const endIndex = Math.min(bulletsArray.length - 1, startIndex + 5) // Muestra hasta 6 elementos máximo

    // Crear un rango de índices para los bullets visibles
    const visibleBullets = bulletsArray.slice(startIndex, endIndex + 1)
    const currentIndexInVisibleBullets = currentIndex - startIndex

    const [animation] = useState(new Animated.Value(0))

    return (
        <View style={[styles.bulletsContainer]}>
            <View style={[styles.bulletsIndicator]}>
                {visibleBullets.map((_, index) => {
                    const scale = animation.interpolate({
                        inputRange: [index - 1, index, index + 1],
                        outputRange: [0.8, 1, 0.8],
                        extrapolate: 'clamp',
                    })

                    const opacity = animation.interpolate({
                        inputRange: [index - 1, index, index + 1],
                        outputRange: [0.4, 1, 0.4],
                        extrapolate: 'clamp',
                    })

                    return (
                        <Animated.View
                            key={`bullet-${index}`}
                            accessible={false}
                            importantForAccessibility='no'
                            style={[
                                styles.circleBulletIndicator,
                                { opacity, transform: [{ scale }] },
                                index === currentIndexInVisibleBullets ? styles.currentBulletIndicator : null,
                            ]}
                        />
                    )
                })}
            </View>
        </View>
    )
}
const styles = StyleSheet.create({
    bulletsContainer: {
        flexDirection: 'row',
        width: '100%',
        alignSelf: 'center',
        alignContent: 'center',
        justifyContent: 'center',
    },
    bulletsIndicator: {
        flexDirection: 'row',
        paddingVertical: 5,
        paddingHorizontal: 10,
        bottom: 0,
        alignSelf: 'center',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
    },
    currentBulletIndicator: {
        width: 25,
        height: 6,
        borderRadius: 5,
        backgroundColor: theme.colors.colorPrimary,
        opacity: 1.0,
        marginHorizontal: 2,
    },
    circleBulletIndicator: {
        width: 6,
        height: 6,
        borderRadius: 5,
        backgroundColor: theme.colors.colorPrimary,
        opacity: 0.5,
        marginHorizontal: 2,
    },
})
